// Injury status constants and utilities

export const INJURY_STATUS = {
  HEALTHY: 'H',
  QUESTIONABLE: 'Q',
  DOUBTFUL: 'D',
  OUT: 'O'
} as const;

export type InjuryStatus = typeof INJURY_STATUS[keyof typeof INJURY_STATUS];

export const INJURY_STATUS_LABELS = {
  [INJURY_STATUS.HEALTHY]: 'Healthy',
  [INJURY_STATUS.QUESTIONABLE]: 'Questionable',
  [INJURY_STATUS.DOUBTFUL]: 'Doubtful',
  [INJURY_STATUS.OUT]: 'Out'
} as const;

export const INJURY_STATUS_COLORS = {
  [INJURY_STATUS.HEALTHY]: 'text-green-700 bg-green-100 border-green-200',
  [INJURY_STATUS.QUESTIONABLE]: 'text-yellow-700 bg-yellow-100 border-yellow-200',
  [INJURY_STATUS.DOUBTFUL]: 'text-orange-700 bg-orange-100 border-orange-200',
  [INJURY_STATUS.OUT]: 'text-red-700 bg-red-100 border-red-200'
} as const;

export const INJURY_STATUS_OPTIONS = [
  { value: INJURY_STATUS.HEALTHY, label: INJURY_STATUS_LABELS[INJURY_STATUS.HEALTHY] },
  { value: INJURY_STATUS.QUESTIONABLE, label: INJURY_STATUS_LABELS[INJURY_STATUS.QUESTIONABLE] },
  { value: INJURY_STATUS.DOUBTFUL, label: INJURY_STATUS_LABELS[INJURY_STATUS.DOUBTFUL] },
  { value: INJURY_STATUS.OUT, label: INJURY_STATUS_LABELS[INJURY_STATUS.OUT] }
] as const;

/**
 * Determines if a player needs to be auto-substituted based on injury status
 */
export const shouldAutoSubstitutePlayer = (injuryStatus: InjuryStatus): boolean => {
  return injuryStatus === INJURY_STATUS.OUT;
};

/**
 * Gets the display text for an injury status
 */
export const getInjuryStatusLabel = (injuryStatus: InjuryStatus): string => {
  return INJURY_STATUS_LABELS[injuryStatus] || 'Unknown';
};

/**
 * Gets the CSS classes for injury status display
 */
export const getInjuryStatusClasses = (injuryStatus: InjuryStatus): string => {
  return INJURY_STATUS_COLORS[injuryStatus] || '';
}; 